import Icon from './Icon';

import Bottom from './icons/bottom.svg';
import Clear from './icons/clear.svg';
import First from './icons/first.svg';
import Last from './icons/last.svg';
import Next from './icons/next.svg';
import Previous from './icons/previous.svg';
import Search from './icons/search.svg';
import Top from './icons/top.svg';
import Check from './icons/check.svg';
import Bin from './icons/bin.svg';
import Settings from './icons/settings.svg';
import Close from './icons/close.svg';
import Oops from './icons/oops.svg';
import Dnd from './icons/dnd.svg';
import Plus from './icons/plus.svg';
import More from './MoreIcon';

export const BottomIcon = Bottom;
export const ClearIcon = Icon()(Clear);
export const FirstIcon = Icon()(First);
export const LastIcon = Icon()(Last);
export const NextIcon = Icon()(Next);
export const PreviousIcon = Icon()(Previous);
export const SearchIcon = Icon()(Search);
export const TopIcon = Icon()(Top);
export const CheckIcon = Icon()(Check);
export const BinIcon = Icon()(Bin);
export const SettingsIcon = Icon()(Settings);
export const CloseIcon = Close;
export const OopsIcon = Icon()(Oops);
export const DndIcon = Icon()(Dnd);
export const PlusIcon = Icon()(Plus);
export const MoreIcon = More;
